export const TASK_THRESHOLD = 0;

export const TIME_PATTERN = "hh:mm A";

export const DEFAULT_COUNT = 0;

export const MAX_COMMENTS = 10;
